var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "a-row",
        [
          _c(
            "a-row",
            { attrs: { gutter: 4 } },
            [
              _c("a-col", { attrs: { span: 4 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("抽样品种选择"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 6 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("抽样比例"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 11 } }, [
                _c("span", { staticClass: "list-header" }, [
                  _vm._v("污染物选择"),
                ]),
              ]),
              _c("a-col", { attrs: { span: 3 } }),
            ],
            1
          ),
          _vm._l(_vm.localValue, function (item) {
            return _c(
              "a-row",
              { style: { margin: "4px" }, attrs: { gutter: 4 } },
              [
                _c(
                  "a-col",
                  { attrs: { span: 4 } },
                  [
                    _c("a-ext-check-box", {
                      attrs: {
                        disabled: _vm.disabled,
                        label: item.produceName,
                        width: "90%",
                      },
                      model: {
                        value: item.checked,
                        callback: function ($$v) {
                          _vm.$set(item, "checked", $$v)
                        },
                        expression: "item.checked",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "a-col",
                  { attrs: { span: 6 } },
                  [
                    _c("a-input-number", {
                      attrs: {
                        disabled: _vm.disabled,
                        allowClear: "",
                        min: 0,
                        max: 100,
                        formatter: function (value) {
                          return value + "%"
                        },
                        parser: function (value) {
                          return value.replace("%", "")
                        },
                        placeholder: "请输入抽检数量",
                      },
                      model: {
                        value: item.pickPercent,
                        callback: function ($$v) {
                          _vm.$set(item, "pickPercent", $$v)
                        },
                        expression: "item.pickPercent",
                      },
                    }),
                  ],
                  1
                ),
                _c("a-col", { attrs: { span: 11 } }, [
                  _c(
                    "div",
                    {
                      staticClass: "box",
                      staticStyle: { "text-align": "left" },
                    },
                    [
                      _vm._v(" " + _vm._s(item.badThings) + " "),
                      !item.badThings && !_vm.disabled
                        ? _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.reChoice(item)
                                },
                              },
                            },
                            [_vm._v(" 添加 ")]
                          )
                        : _vm._e(),
                      _c("div", {
                        staticStyle: {
                          display: "inline-block",
                          height: "25px",
                          width: "1px",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c(
                  "a-col",
                  { attrs: { span: 3 } },
                  [
                    item.badThings && !_vm.disabled
                      ? _c(
                          "a-button",
                          {
                            attrs: { type: "link" },
                            on: {
                              click: function ($event) {
                                return _vm.reChoice(item)
                              },
                            },
                          },
                          [_vm._v("重新选择")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm.modalVisable
        ? _c("bad-check-panel-modal", {
            attrs: { visible: _vm.modalVisable, param: _vm.modalParam },
            on: {
              "update:visible": function ($event) {
                _vm.modalVisable = $event
              },
              dialogBack: _vm.onModalClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "big-title" }, [
      _c("span", [_vm._v("抽样品种及污染物选择")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }